import React from "react"
import { Box, DialogContentText, DialogTitle, Link } from "@carrotfertility/carotene-core"
import { IlloCircleCarrotCards } from "#/components/views/atoms/Illustrations"
import { FormattedMessage } from "react-intl"
import { DbgPaths } from "#/utils/Paths"
import useBenefit from "#/components/dynamic-content/hooks/useGetBenefit"

export function CardRequestPending() {
  const benefit = useBenefit()
  const isSupportCenterEnabled = benefit?.data?.supportCenter.enabled

  return (
    <div>
      <Box
        sx={{
          display: "flex",
          flexDirection: "row",
          justifyContent: "center",
          marginBlockStart: (theme) => theme.tokens.spacing.xl
        }}
      >
        <IlloCircleCarrotCards />
      </Box>
      <DialogTitle>
        <FormattedMessage defaultMessage="We’re preparing your card." />
      </DialogTitle>
      <DialogContentText>
        <FormattedMessage defaultMessage="You will receive an email and SMS confirmation when your card is ready." />
      </DialogContentText>
      {isSupportCenterEnabled && (
        <Link
          sx={{ display: "inline-block", marginBlockStart: (theme) => theme.tokens.spacing.md }}
          href={DbgPaths.CARROT_CARD}
          target="_blank"
        >
          <FormattedMessage defaultMessage="Learn more about Carrot Card" />
        </Link>
      )}
    </div>
  )
}
